var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("el-alert", {
            attrs: {
              title: "路由配置是非常专业的事情，不建议非工程师操作",
              type: "warning",
            },
          }),
          _c("vue-json-editor", {
            attrs: { "show-btns": false },
            model: {
              value: _vm.json,
              callback: function ($$v) {
                _vm.json = $$v
              },
              expression: "json",
            },
          }),
          _c(
            "div",
            { attrs: { align: "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.edit()
                    },
                  },
                },
                [_vm._v("更新")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }